"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconUsers = function IconUsers(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconUsers', className),
    style: style,
    viewBox: "0 0 21 17"
  }, _react.default.createElement("g", {
    id: "final",
    stroke: "currentColor",
    strokeWidth: "0",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "icons",
    transform: "translate(-140.000000, -135.000000)"
  }, _react.default.createElement("g", {
    id: "Group-7",
    transform: "translate(139.000000, 131.000000)"
  }, _react.default.createElement("rect", {
    id: "Rectangle-2",
    fillOpacity: "0",
    fill: "currentColor",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), _react.default.createElement("g", {
    id: "Group-6",
    transform: "translate(2.000000, 5.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "Group-5"
  }, _react.default.createElement("path", {
    d: "M8.75,7.35 L3.5,7.35 C1.20801829,7.35 -0.65,9.20801829 -0.65,11.5 L-0.65,14 C-0.65,14.9112698 0.0887301628,15.65 1,15.65 L11.25,15.65 C12.1612698,15.65 12.9,14.9112698 12.9,14 L12.9,11.5 C12.9,9.20801829 11.0419817,7.35 8.75,7.35 Z M3.5,8.65 L8.75,8.65 C10.3240115,8.65 11.6,9.92598846 11.6,11.5 L11.6,14 C11.6,14.1932997 11.4432997,14.35 11.25,14.35 L1,14.35 C0.806700338,14.35 0.65,14.1932997 0.65,14 L0.65,11.5 C0.65,9.92598846 1.92598846,8.65 3.5,8.65 Z",
    id: "Rectangle"
  }), _react.default.createElement("path", {
    d: "M6.07619048,-0.65 C4.02187015,-0.65 2.35,0.980461605 2.35,3 C2.35,5.01953839 4.02187015,6.65 6.07619048,6.65 C8.1305108,6.65 9.80238095,5.01953839 9.80238095,3 C9.80238095,0.980461605 8.1305108,-0.65 6.07619048,-0.65 Z M6.07619048,0.65 C7.41973633,0.65 8.50238095,1.7058299 8.50238095,3 C8.50238095,4.2941701 7.41973633,5.35 6.07619048,5.35 C4.73264462,5.35 3.65,4.2941701 3.65,3 C3.65,1.7058299 4.73264462,0.65 6.07619048,0.65 Z",
    id: "Oval"
  })), _react.default.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(13.000000, 4.000000)"
  }, _react.default.createElement("path", {
    d: "M3.83333333,5.35 C5.42213821,5.35 6.72086276,6.59198152 6.81160227,8.15803984 L6.81666667,8.33333333 L6.81666667,9.66666667 C6.81666667,10.5299749 6.15365123,11.2384276 5.30903498,11.3106102 L5.16666667,11.3166667 L1,11.3166667 C0.641014913,11.3166667 0.35,11.0256518 0.35,10.6666667 C0.35,10.3403166 0.590508192,10.0701402 0.903947764,10.0237143 L1,10.0166667 L5.16666667,10.0166667 C5.33580387,10.0166667 5.47691972,9.89669297 5.50955591,9.73720387 L5.51666667,9.66666667 L5.51666667,8.33333333 C5.51666667,7.4525845 4.84025698,6.72981961 3.97857778,6.65617884 L3.83333333,6.65 L1,6.65 C0.641014913,6.65 0.35,6.35898509 0.35,6 C0.35,5.67364992 0.590508192,5.40347354 0.903947764,5.35704767 L1,5.35 L3.83333333,5.35 Z",
    id: "Path"
  }), _react.default.createElement("path", {
    d: "M2.05079365,-0.65 C0.562784357,-0.65 -0.65,0.532746355 -0.65,2 C-0.65,3.46725365 0.562784357,4.65 2.05079365,4.65 C3.53880294,4.65 4.7515873,3.46725365 4.7515873,2 C4.7515873,0.532746355 3.53880294,-0.65 2.05079365,-0.65 Z M2.05079365,0.65 C2.82802847,0.65 3.4515873,1.25811465 3.4515873,2 C3.4515873,2.74188535 2.82802847,3.35 2.05079365,3.35 C1.27355883,3.35 0.65,2.74188535 0.65,2 C0.65,1.25811465 1.27355883,0.65 2.05079365,0.65 Z",
    id: "Oval"
  })))))));
};

var _default = IconUsers;
exports.default = _default;